import { NavLink, NavLinkProps, NavLinkRenderProps } from 'react-router-dom'

const base = 'inline-block px-4 py-2 -mb-px border-b-2 font-medium text-sm transition'
const inactive = 'text-gray-600 border-transparent hover:text-blue-600 hover:border-blue-600'
const active = 'text-blue-600 border-blue-600'

const tabClassName = ({ isActive }: NavLinkRenderProps) => `${base} ${isActive ? active : inactive}`

export function Tab(props: Omit<NavLinkProps, 'className'>) {
	return <NavLink {...props} className={tabClassName} />
}
